import { Outlet } from 'react-router-dom';
import { SiteProvider } from '../../context/SiteContext';

export default function SiteProviderLayout() {
  return (
    <SiteProvider>
      <Outlet />
    </SiteProvider>
  );
}
